import { shareUrlModal } from '../../constants/modal-type';
import {
  AdditionalActionId,
  BIEvent,
  ProfileActionType,
  Thunk,
  ThunkWithArgs,
} from '../../types';
import { openModalWithCallback } from '../../services/modal';
import { togglePublicProfilePreview } from './public-profile-preview';
import { emitBIEventWithPayload } from '../../services/bi-event';

type AdditionalActionsMap = {
  [key in AdditionalActionId]: Thunk;
};

const shareProfile: Thunk = () => async (_, getState, extra) => {
  const { compId, platformAPIs, wixCodeApi } = extra;
  const payload = { url: wixCodeApi.location.url };
  const onConfirm = () => {};

  openModalWithCallback({
    compId,
    modalType: shareUrlModal,
    payload,
    platformAPIs,
    wixCodeApi,
    onConfirm,
  });
  emitBIEventWithPayload({
    state: getState(),
    extra,
    biEvent: BIEvent.RoleActionClicked,
    payload: {
      action_type: ProfileActionType.SHARE_PROFILE,
    },
  });
};

const actionsMap: AdditionalActionsMap = {
  [AdditionalActionId.ShareProfile]: shareProfile,
  [AdditionalActionId.ViewPublicProfile]: togglePublicProfilePreview,
};

export const executeAdditionalAction: ThunkWithArgs<AdditionalActionId> = (
  actionId,
) => async (dispatch, getState, extra) => {
  const actionHandler = actionsMap[actionId];
  if (!actionHandler) {
    return;
  }
  await actionHandler()(dispatch, getState, extra);
};
